import {computed, Injectable} from "@angular/core";
import {CallStoreService} from './call-store.service';
import {ZimService} from '../../../services/zim.service';
import {isNetworkBad} from '../../../utils/device.util';

@Injectable({ providedIn: 'root' })
export class UiStatusBarService {
  constructor(
    private callStore: CallStoreService,
    private zimService: ZimService,
  ) {
  }

  readonly showStatusBar = computed(() => {
    let isCalling = this.callStore.showCallStatusBar();
    let networkBad = isNetworkBad(this.zimService.connectionState());
    return isCalling || networkBad;
  })
}
